import * as Sentry from '@sentry/react';

import { ToasterProvider } from '@crossnokaye/ux-common';

import { AppProviders } from '@/providers/app-providers';
import { RouterProvider } from '@/providers/router-provider';

import { ErrorBoundaryProvider } from './providers/error-boundary-provider';
import { JotaiProvider } from './providers/jotai/jotai-provider';
import { QueryProvider } from './providers/query-provider';

/**
 * Provides the main application providers and router
 * Wrapped with Sentry profiler for performance monitoring
 */
export const Root = Sentry.withProfiler(
  () => (
    <ErrorBoundaryProvider>
      <ToasterProvider>
        <QueryProvider>
          <JotaiProvider>
            <AppProviders>
              <RouterProvider />
            </AppProviders>
          </JotaiProvider>
        </QueryProvider>
      </ToasterProvider>
    </ErrorBoundaryProvider>
  ),
  { name: 'Gaia' }
);
